// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2ZToZ","search":"Settings_search__2oUoh","filter":"Settings_filter__1UKZA"};